import { Phone, Mail, MapPin, Recycle } from "lucide-react";
import {
    PHONE_DISPLAY,
    PHONE_HREF,
    EMAIL,
    EMAIL_HREF,
    SERVICE_AREA,
    ABN,
    LOGO_URL,
    BUSINESS_NAME,
} from "@/lib/contact";

const NAV = [
    { href: "/#bin-sizes", label: "Bin Sizes", slug: "bin-sizes" },
    { href: "/#what-we-take", label: "What We Take", slug: "what-we-take" },
    { href: "/#why-us", label: "Why Choose Us", slug: "why-us" },
    { href: "/#how-it-works", label: "How It Works", slug: "how-it-works" },
    { href: "/#service-area", label: "Service Area", slug: "service-area" },
    { href: "/blog", label: "Blog", slug: "blog" },
    { href: "/#quote", label: "Get a Quote", slug: "quote" },
];

export const Footer = () => {
    const year = new Date().getFullYear();
    return (
        <footer data-testid="site-footer" className="bg-tp-forest text-white mt-8 md:mt-0">
            <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-10 md:py-14 grid gap-8 md:grid-cols-3">
                {/* Brand */}
                <div>
                    <a
                        href="#top"
                        className="inline-flex items-center gap-2"
                        aria-label={`${BUSINESS_NAME} home`}
                    >
                        <img
                            src={LOGO_URL}
                            alt="Tipping Point Skips logo"
                            className="h-14 w-auto"
                            draggable={false}
                        />
                    </a>
                    <p className="mt-4 text-sm text-white/80 max-w-xs">
                        Family owned skip bin hire across Sydney — fast delivery, fair pricing,
                        and responsible waste disposal on every job.
                    </p>
                    <div className="mt-4 inline-flex items-center gap-2 text-xs text-tp-gold">
                        <Recycle size={14} className="text-tp-recycle" />
                        Recycling & responsible disposal wherever possible
                    </div>
                </div>

                {/* Contact */}
                <div>
                    <div className="text-xs uppercase tracking-[0.16em] text-tp-gold font-semibold">
                        Contact
                    </div>
                    <ul className="mt-3 space-y-2 text-sm">
                        <li>
                            <a
                                href={PHONE_HREF}
                                data-testid="footer-phone-link"
                                className="inline-flex items-center gap-2 hover:text-tp-gold transition-colors"
                            >
                                <Phone size={16} strokeWidth={2.4} className="text-tp-gold" />
                                <span className="font-semibold tabular-nums">{PHONE_DISPLAY}</span>
                            </a>
                        </li>
                        <li>
                            <a
                                href={EMAIL_HREF}
                                data-testid="footer-email-link"
                                className="inline-flex items-center gap-2 hover:text-tp-gold transition-colors break-all"
                            >
                                <Mail size={16} strokeWidth={2.4} className="text-tp-gold" />
                                <span>{EMAIL}</span>
                            </a>
                        </li>
                        <li>
                            <div
                                data-testid="footer-service-area"
                                className="inline-flex items-start gap-2 text-white/85"
                            >
                                <MapPin size={16} strokeWidth={2.4} className="text-tp-gold mt-0.5 shrink-0" />
                                <span>Servicing {SERVICE_AREA}</span>
                            </div>
                        </li>
                    </ul>
                    <div className="mt-4">
                        <a
                            href={PHONE_HREF}
                            data-testid="footer-call-button"
                            className="tp-btn-primary text-sm h-11 tp-focus"
                        >
                            <Phone size={16} strokeWidth={2.6} />
                            Call for a quote
                        </a>
                    </div>
                </div>

                {/* Nav */}
                <div>
                    <div className="text-xs uppercase tracking-[0.16em] text-tp-gold font-semibold">
                        Explore
                    </div>
                    <ul className="mt-3 grid grid-cols-2 gap-y-2 text-sm">
                        {NAV.map((item) => (
                            <li key={item.href}>
                                <a
                                    href={item.href}
                                    data-testid={`footer-nav-${item.slug}`}
                                    className="text-white/85 hover:text-tp-gold transition-colors"
                                >
                                    {item.label}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>

            <div className="border-t border-white/10">
                <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-white/70">
                    <p>
                        © {year} {BUSINESS_NAME}. All rights reserved.
                    </p>
                    <p data-testid="footer-abn">
                        ABN <span className="tabular-nums">{ABN}</span>
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
